import React, { createContext, FC, ReactNode, useMemo, useState } from 'react'
import { GeckoMeasurement, GeckoMeasurementUnit } from 'types'

import {
  DEFAULT_STRESS_VALUE,
  DEFAULT_TENSILTE_STRENGTH,
} from './mawp/allowableStress/MetalAllowableStressTable'
import { ValueSetterPair } from './typeUtils'

type MeasurementType = GeckoMeasurement | null
export type FfsSharedValuesType = ValueSetterPair<MeasurementType, 'fca'> &
  ValueSetterPair<MeasurementType, 'fcaMl'> &
  ValueSetterPair<MeasurementType, 'jointEfficiency'> &
  ValueSetterPair<MeasurementType, 'yieldStrength'> &
  ValueSetterPair<MeasurementType, 'tensileStrength'>

function useCreateFfsSharedValues(): FfsSharedValuesType {
  const [fca, setFca] = useState<MeasurementType>(
    GeckoMeasurement.CreateFromValue(0, GeckoMeasurementUnit.Millimeters)
  )
  const [fcaMl, setFcaMl] = useState<MeasurementType>(
    GeckoMeasurement.CreateFromValue(0, GeckoMeasurementUnit.Millimeters)
  )
  const [jointEfficiency, setJointEfficiency] = useState<MeasurementType>(
    GeckoMeasurement.CreateFromValue(1, GeckoMeasurementUnit.Ratio)
  )
  const [yieldStrength, setYieldStrength] =
    useState<MeasurementType>(DEFAULT_STRESS_VALUE)
  const [tensileStrength, setTensileStrength] = useState<MeasurementType>(
    DEFAULT_TENSILTE_STRENGTH
  )

  return useMemo(
    () => ({
      fca,
      setFca,
      fcaMl,
      setFcaMl,
      jointEfficiency,
      setJointEfficiency,
      yieldStrength,
      setYieldStrength,
      tensileStrength,
      setTensileStrength,
    }),
    [fca, fcaMl, jointEfficiency, tensileStrength, yieldStrength]
  )
}

export const FfsSharedValuesContext = createContext<FfsSharedValuesType>({
  fca: null,
  setFca: () => {},
  fcaMl: null,
  setFcaMl: () => {},
  jointEfficiency: null,
  setJointEfficiency: () => {},
  yieldStrength: null,
  setYieldStrength: () => {},
  tensileStrength: null,
  setTensileStrength: () => {},
})

export const FfsSharedValueProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <FfsSharedValuesContext.Provider value={useCreateFfsSharedValues()}>
      {children}
    </FfsSharedValuesContext.Provider>
  )
}
